export const phieuNhapKho = {
  sections: {
    list: { title: 'Stock-in vouchers' },
    detail: { title: 'Stock-in details' },
    lines: 'Line items',
  },
  titles: { add: 'Add new', addNew: 'Add new' },
  columns: {
    tongSoLuong: 'Total qty',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    code: 'Voucher no.',
    chiNhanh: 'Branch',
    loaiPhieu: 'Type',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chiNhanhDoi: 'Counter branch',
    trangThai: 'Status',
    tongTienHang: 'Subtotal',
    phieuTraNguon: 'Source return voucher',
    maHoaDon: 'Invoice no.',
  },
  placeholders: {
    toolbarSearch: 'Search',
    maLoRequired: 'Required (expiry-managed product)',
    maLoOptional: 'Leave empty if not lot-tracked',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  fields: {
    code: 'Voucher no.',
    chiNhanh: 'Branch',
    loaiPhieu: 'Type',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chiNhanhDoi: 'Counter branch',
    lyDo: 'Reason',
    ghiChu: 'Note',
    phieuChuyen: 'Transfer voucher',
    status: 'Status',
    totalAmount: 'Subtotal',
    giamGiaPhieu: 'Voucher discount',
    tongSauGiamGia: 'Net amount',
    product: 'Product',
    productCode: 'SKU',
    productName: 'Name',
    productSearch: 'Search product',
    qty: 'Qty',
    unitPrice: 'Unit price',
    donGiaMua: 'Purchase unit price',
    donGiaVon: 'Cost unit price',
    donViTinhMua: 'Purchase UoM',
    maSp: 'SKU',
    tenSp: 'Product name',
    hinhThucVc: 'Shipping method',
    cont: 'Container',
    maVanChuyenNcc: 'Supplier shipment no.',
    maVanChuyenAzl: 'AZL shipment no.',
    maYcmh: 'PR no.',
    maBaoGia: 'Quote no.',
    giamGia: 'Discount',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Product date',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lineAmount: 'Line total',
    lineGhiChu: 'Line note',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  loaiPhieu: {
    NHAP_MUA: 'Purchase in',
    NHAP_CHUYEN: 'Transfer in',
    NHAP_TRA_HANG: 'Return in',
    NHAP_DIEU_CHINH: 'Adjustment in',
    NHAP_KHAC: 'Other in',
    KIEM_KE: 'Stock take',
  },
  detailTabs: {
    chung: 'Overview',
    generalInfo: 'Info',
    chiTietHang: 'Line items',
    lines: 'Line items',
  },
  form: {
    loaiPhieu: 'Type',
    maPhieu: 'Voucher no.',
    maPhieuAuto: 'Auto-generated on save',
    ngayChungTu: 'Voucher date',
    nhaCungCap: 'Supplier',
    khachHang: 'Customer',
    chiNhanhDoi: 'Counter branch',
    lyDo: 'Reason',
    ghiChu: 'Voucher note',
    note: 'Voucher note',
    sectionHeader: 'General info',
    sectionLines: 'Line items',
    sectionSummary: 'Summary',
    product: 'Product',
    productSearch: 'Search code / name',
    qty: 'Qty',
    unitPrice: 'Unit price',
    donGiaMua: 'Purchase unit price',
    donGiaVon: 'Cost unit price',
    donViTinhMua: 'Purchase UoM',
    maSp: 'SKU',
    tenSp: 'Product name',
    hinhThucVc: 'Shipping method',
    cont: 'Container',
    maVanChuyenNcc: 'Supplier shipment no.',
    maVanChuyenAzl: 'AZL shipment no.',
    maYcmh: 'PR no.',
    maBaoGia: 'Quote no.',
    giamGia: 'Discount',
    giamGiaPhieu: 'Voucher discount',
    tongSauGiamGia: 'Net amount',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Product date',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lineNote: 'Line note',
    lineAmount: 'Line amount',
    tongTienHang: 'Subtotal',
    tongSoMatHang: 'SKU count',
    tongSoLuong: 'Total qty',
    lineCount: '{count} lines',
    emptyAddProduct: 'Search and pick a product above to add a line.',
    emptyAddProductPos: 'Type a product code/name in the blue bar (F3) to add a line.',
    save: 'Save',
    lotRequired: 'Lot no. required (expiry-managed)',
    expiryRequired: 'Expiry date required (expiry-managed)',
  },
  status: {
    phieuTam: 'Draft',
    cho: 'Pending',
    daHoanThanh: 'Received',
    daHuy: 'Cancelled',
  },
  filter: {
    title: 'Filter',
    loaiPhieu: 'Type',
    trangThai: 'Status',
    nhaCungCap: 'Supplier',
    tuNgay: 'From date',
    denNgay: 'To date',
    fromDate: 'From date',
    toDate: 'To date',
    dateRangePlaceholder: 'Select date range',
    all: 'All',
    reset: 'Reset',
    sortDir: 'Order',
    asc: 'Ascending',
    desc: 'Descending',
    advancedTitle: 'Advanced filters',
    nccTreeAll: 'All suppliers',
    nccTreeSearch: 'Search suppliers',
    nccTreeEmpty: 'No suppliers',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
  },
  actions: {
    complete: 'Complete',
    cancelVoucher: 'Cancel voucher',
    copy: 'Copy voucher',
    addLine: 'Add empty line',
    importExcel: 'Import Excel',
    downloadTemplate: 'Download template',
    dongY: 'Agree',
  },
  messages: {
    importDescription:
      'Download the template (* = required, same as manual entry). Fill lines; pick voucher type and supplier / counter branch below when needed. One file = one draft.',
    importSuccess: 'Imported products from Excel.',
    importWillCreate: 'Will create 1 goods receipt from {count} line(s).',
    importPreviewProgress: 'Preview goods receipt',
    importPreviewLoading: 'Preparing goods receipt…',
    importPreviewDone: 'Goods receipt created from preview.',
    importChiNhanhNhan: 'Receiving branch (current)',
    importChiNhanhChuyen: 'Shipping branch (counter)',
    importNeedNcc: 'Purchase stock-in requires a supplier.',
    importNeedChiNhanhDoi: 'Transfer stock-in requires a counter (shipping) branch.',
    loadError: 'Failed to load stock-in vouchers.',
    noData: 'No stock-in vouchers yet.',
    listSummary: 'Total: {count}',
    createSuccess: 'Stock-in voucher created and stock increased.',
    updateSuccess: 'Stock-in voucher updated.',
    deleteSuccess: 'Stock-in voucher deleted.',
    needLines: 'Add at least one line item.',
    needNgayChungTu: 'Select a voucher date before saving.',
    validateNgayChungTuBeforeNgayTao: 'Invalid voucher date.',
    needNhaCungCap: 'Select a supplier before saving.',
    needChiNhanhDoi: 'Select a counter branch before saving.',
    nhapTraHangBlocked:
      'Return receipts cannot be created here. Create them from a sales return (needs both cost and selling price).',
    needMaSp: 'Enter SKU for every line.',
    needTenSp: 'Enter product name for every line.',
    needSoLuong: 'Enter quantity (> 0) for every line.',
    needDonViTinhMua: 'Enter purchase UoM for every line.',
    needMaLo: 'Enter lot no. for {code}.',
    needHanSuDung: 'Enter expiry date for {code}.',
    giamGiaVuotDonGia: 'Discount for {code} cannot exceed the unit price.',
    soKhongDuocAm: 'Quantity, unit price and discount cannot be negative.',
    completeSuccess: 'Stock-in voucher completed.',
    cancelVoucherSuccess: 'Stock-in voucher cancelled.',
    notFound: 'Voucher not found.',
    noLines: 'No line items.',
    loadingLines: 'Loading lines…',
    confirmDelete: 'Delete {name}?',
    confirmComplete: 'Complete voucher {name}? Stock will be updated.',
    confirmCancelVoucher: 'Cancel voucher {name}? Received stock will be deducted. This cannot be undone.',
  },
}
